import React from "react";
import {useTranslation} from "react-i18next";
import {UserWithStats} from "../../models/UserWithStats";
import {useNavigate} from "react-router";
import {UiFlag} from "../ui-components/flag/UiFlag";
import {LeaderboardStrategy} from "../../models/leaderboard/leaderboardStrategy";

type LeaderboardItemType = {
    user: UserWithStats,
    leaderboardStrategy: LeaderboardStrategy,
}

export const LeaderboardItem: React.FC<LeaderboardItemType> = (props) => {
    const {t} = useTranslation();
    const navigate = useNavigate();
    
    function getTextSize() {
        if (props.user.rank <= 10) {
            return "text-2xl";
        }
        
        return "text-xl";
    }
    
    return (
        <div className={"flex bg-deep-blue rounded-xl w-full p-3 " +
            "hover:bg-deep-blue-hover cursor-pointer items-center gap-4 px-2 lg:px-6 "}
            onClick={() => navigate(`/stats?player-id=${props.user.id}`)}
        >
            <p className={getTextSize()}>{`#${props.user.rank}`}</p>

            <img
                className="w-16 md:w-14 h-16 md:h-14 rounded-full"
                src={props.user.getPP()}
                alt={`${props.user.name} profile picture`}
            />

            <div className="flex flex-col xl:w-full xl:flex-row xl:justify-between">
                <div className="flex max-xs:flex-wrap items-center gap-4">
                    <p className="text-2xl text-wrap break-all lg:text-xl">{props.user.name}</p>
                    {props.user.country && <UiFlag className="min-w-8 h-5" countryCode={props.user.country}/>}
                </div>

                <div className="flex gap-8">
                    {props.leaderboardStrategy.getGamemodeInformations(t, props.user)}
                </div>
            </div>
        </div>
    )
}
